import { ImageHotspot } from '../imageWithBackground/ImageHotspot';
/***
 * Represents a hotspot that changes the scene in attached virtual tour.
 */
export class SceneLinkHotspot {
    constructor(parameters, iconBundle, assetUrls) {
        var _a;
        this._virtualTourInWhichChangeScenes = null;
        this._onClick = undefined;
        this.attach = (virtualTour) => {
            this._virtualTourInWhichChangeScenes = virtualTour;
            this._hotspot.attach(virtualTour);
        };
        this.updateDestinationScene = (destinationTourSceneGuid) => (this._destinationTourSceneGuid = destinationTourSceneGuid);
        this.updateIcon = (iconId, hasTilt) => this._hotspot.updateIcon(iconId, hasTilt);
        this.updateSceneCoordinates = (sceneCoordinates) => this._hotspot.updateSceneCoordinates(sceneCoordinates);
        this.updateVirtualTourPosition = (virtualTourPosition) => this._hotspot.updateVirtualTourPosition(virtualTourPosition);
        this.updateDestinationLabel = (destinationLabel) => this._hotspot.updateDestinationLabel(destinationLabel);
        this.updateIsDragAndDropAllowed = (isAllowed) => this._hotspot.updateIsDragAndDropAllowed(isAllowed);
        this.lookTo = () => this._hotspot.lookTo();
        this.detach = () => this._hotspot.detach();
        this.handleOnClick = () => {
            if (!this._virtualTourInWhichChangeScenes) {
                return;
            }
            if (this._onClick) {
                this._onClick(this._virtualTourInWhichChangeScenes, this._destinationTourSceneGuid);
            }
            else {
                void this._virtualTourInWhichChangeScenes.changeScene(this._destinationTourSceneGuid, 0);
            }
        };
        this._destinationTourSceneGuid = parameters.destinationTourSceneGuid;
        this._hotspot = new ImageHotspot(parameters.position, (_a = parameters.destinationLabel) !== null && _a !== void 0 ? _a : null, parameters.hasTilt, iconBundle, assetUrls);
        this._onClick = parameters.onClick;
        this._hotspot.updateOnClick(this.handleOnClick);
    }
}
